// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Fuel/font/digital-7.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*media breaks*/
@font-face {
  font-family: "digital-clock-font";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
@keyframes upDown {
  0% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
  100% {
    transform: translateY(0);
  }
}
.paypoint {
  display: flex;
  flex-direction: column;
  background-color: #e4ffff;
  max-width: 97.9vw;
  align-content: center;
  justify-content: flex-start;
}
.paypoint #context-menu {
  display: none;
  color: #fff;
  background-color: #2c53a0;
  width: 9vw;
}
.paypoint #context-menu ul {
  list-style-type: none;
}
.paypoint #context-menu ul li {
  cursor: pointer;
}
.paypoint #context-menu ul li:hover {
  transform: scale(1.2);
  transition: 0.5s;
}
.paypoint .paypoint__main {
  display: flex;
  flex-direction: column;
  background-color: #e4ffff;
  min-height: 49.5vh;
  width: 80%;
  margin: auto;
  margin-top: 2%;
}
.paypoint .paypoint__main h1 {
  font-size: 2rem;
  margin-top: 0;
}
.paypoint .paypoint__main .select_row {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 60vw;
  margin: 0 auto;
}
.paypoint .paypoint__main .select_row select {
  width: 25%;
  padding: 1%;
  border-radius: 1rem;
  background-color: #fff;
}
.paypoint .paypoint__main .select_row select:focus {
  border: 1px solid #64c4e0;
}
.paypoint .paypoint__main .select_row input[type=date] {
  border: none;
  background-color: #fff;
  border-radius: 1rem;
  height: 4vh;
}
.paypoint .paypoint__main .loader {
  align-self: center;
  margin: 2% auto;
}
.paypoint .paypoint__main .paypoint__info {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 1%;
  margin-left: 0;
}
.paypoint .paypoint__main .paypoint__info .info__card {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 50vw;
  border-radius: 1rem;
  height: 11vh;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  position: relative;
}
.paypoint .paypoint__main .paypoint__info .info__card .card__till {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.paypoint .paypoint__main .paypoint__info .info__card .card__till h3 {
  color: #4d4d4d;
  margin: 0 auto;
}
.paypoint .paypoint__main .paypoint__info .info__card .info__card__icon {
  position: absolute;
  right: 2%;
  bottom: 1.5%;
  animation: upDown 1.5s infinite;
  -webkit-animation: upDown 1.5s infinite;
}
.paypoint .paypoint__main .paypoint__info .info__expand {
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  width: 60vw;
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  margin-top: 2%;
}
.paypoint .paypoint__main .paypoint__info .info__expand table {
  border: 1px solid #4d4d4d;
  border-collapse: collapse;
  width: 100%;
  color: #4d4d4d;
}
.paypoint .paypoint__main .paypoint__info .info__expand table thead th {
  background-color: #2c53a0;
  color: #fff;
}
.paypoint .paypoint__main .paypoint__info .info__expand table tbody tr {
  border: 1px solid #4d4d4d;
  cursor: pointer;
}
.paypoint .paypoint__main .paypoint__info .info__expand table tbody .noteAdded {
  background-image: linear-gradient(225deg, red, red 10px, transparent 10px, transparent);
}
.paypoint .paypoint__main .paypoint__info .info__expand table tbody .matched {
  background-color: #22FF69;
}

.force__match {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.force__match p {
  margin: 0;
  color: #4d4d4d;
}
.force__match select {
  border: 1px solid #2c53a0;
  border-radius: 0.5rem;
}
.force__match .force__buttons {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 80%;
  margin: auto;
  margin-top: 1%;
}
.force__match .force__buttons table {
  color: #4d4d4d;
}
.force__match table {
  width: 100%;
  margin: auto;
  border: 1px solid #4d4d4d;
  border-collapse: collapse;
}
.force__match table thead {
  background-color: #2c53a0;
  color: #fff;
}
.force__match table tbody tr, .force__match table tbody th {
  border: 1px solid #4d4d4d;
  cursor: pointer;
}

@media (max-width: 600px) {
  main h1 {
    font-size: 1.2rem;
  }
  main .select_row select {
    width: 60%;
    height: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/variables.scss","webpack://./src/components/Paypoint/styles/paypointSales.scss"],"names":[],"mappings":"AAOA,eAAA;AAeA;EACI,iCAAA;EACA,4CAAA;ACpBJ;AAFA;EACI;IACI,wBAAA;EAIN;EADE;IACI,2BAAA;EAGN;EAAE;IACI,wBAAA;EAEN;AACF;AACA;EACI,aAAA;EACA,sBAAA;EACA,yBDjBS;ECkBT,iBAAA;EACA,qBAAA;EACA,2BAAA;AACJ;AAAI;EACI,aAAA;EACA,WAAA;EACA,yBD1BI;EC2BJ,UAAA;AAER;AADQ;EACI,qBAAA;AAGZ;AAFY;EACI,eAAA;AAIhB;AAHgB;EACI,qBAAA;EACA,gBAAA;AAKpB;AAAI;EACI,aAAA;EACA,sBAAA;EACA,yBDxCK;ECyCL,kBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AAER;AADQ;EACI,eAAA;EACA,aAAA;AAGZ;AADQ;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AAGZ;AAFY;EACI,UAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;AAIhB;AAHgB;EACI,yBAAA;AAKpB;AAFY;EACI,YAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;AAIhB;AADQ;EACI,kBAAA;EACA,eAAA;AAGZ;AADQ;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,cAAA;AAGZ;AAFY;EACI,sBAAA;EACA,2CAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AAIhB;AAHgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAKpB;AAJoB;EACI,cDjGZ;ECkGY,cAAA;AAMxB;AAHgB;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,+BAAA;EACA,uCAAA;AAKpB;AAFY;EACI,sBAAA;EACA,2CAAA;EACA,WAAA;EACA,aAAA;EACA,6BAAA;EACA,uBAAA;EACA,cAAA;AAIhB;AAHgB;EACI,yBAAA;EACA,yBAAA;EACA,WAAA;EACA,cDzHR;AC8HZ;AAHwB;EACI,yBD/HhB;ECgIgB,WAAA;AAK5B;AADwB;EACI,yBAAA;EAIA,eAAA;AAA5B;AAEwB;EACI,uFAAA;AAA5B;AAEwB;EACI,yBAAA;AAA5B;;AASA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AANJ;AAOI;EACI,SAAA;EACA,cD5JI;ACuJZ;AAOI;EACI,yBAAA;EACA,qBAAA;AALR;AAOI;EACI,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,cAAA;AALR;AAMQ;EACI,cD1KA;ACsKZ;AAOI;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;AALR;AAMQ;EACI,yBDtLA;ECuLA,WAAA;AAJZ;AAOY;EACI,yBAAA;EACA,eAAA;AALhB;;AAYA;EAEQ;IACI,iBAAA;EAVV;EAaU;IACI,UAAA;IACA,YAAA;EAXd;AACF","sourcesContent":["$nitroDark: #2c53a0;\n$nitroLight: #64c4e0;\n$background: #e4ffff;\n$fontColor: #4d4d4d;\n$error: #bb0000;\n$warning: #f29422;\n\n/*media breaks*/\n$mobile: 600px;\n$tablet: 768px;\n$laptop: 900px;\n$tabletMin: 691px;\n$tabletMax: 850px;\n$landsTabletMin: 851px;\n$landsTabletMax: 1300px;\n$smallLaptopMin: 1301px;\n$smallLaptopMax: 1439px;\n$smallScreen: 1440px;\n$regularScreen: 1900px;\n$bigScreen: 1920px;\n$fourK: 2000px;\n\n@font-face {\n    font-family: \"digital-clock-font\";\n    src: url(\"./Fuel/font/digital-7.ttf\");\n}\n\n@mixin shadow {\n    box-shadow: 4px 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n@mixin card {\n    background-color: #fff;\n    @include shadow;\n    border-radius: 1rem;\n}\n\n@mixin alertCard {\n    box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n        rgba(0, 0, 0, 0.23) 0px 6px 6px;\n    background-color: #fff;\n    border-radius: 0.5rem;\n}\n\n@mixin eposCard {\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px,\n        rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px,\n        rgba(0, 0, 0, 0.09) 0px 32px 16px;\n}\n\n@mixin flex($d: row, $j: center, $a: center, $g: 1vw) {\n    display: flex;\n    flex-wrap: wrap;\n    flex-direction: $d;\n    justify-content: $j;\n    align-items: $a;\n    gap: $g;\n}\n\n@mixin columnStack {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin columnStart {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n}\n@mixin columnAlignStart {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: center;\n}\n\n@mixin columnAlignStartTop {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n}\n\n@mixin rowEven {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n    flex-wrap: wrap;\n}\n\n@mixin rowEvenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-evenly;\n}\n@mixin rowEvenStartCenter {\n    display: flex;\n    align-items: center;\n    justify-content: space-evenly;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: center;\n}\n@mixin rowBetween {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n@mixin rowBetweenStart {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\n@mixin rowCenter {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin rowStart {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n@mixin table {\n    table-layout: fixed;\n    background-color: #fff;\n    border-collapse: collapse;\n    color: $fontColor;\n    thead {\n        border-bottom: 1px solid $fontColor;\n        text-align: center;\n    }\n    tbody {\n        text-align: center;\n        tr {\n            border-bottom: 1px solid $fontColor;\n            &:nth-child(odd) {\n                background-color: #f2f2f2;\n            }\n            input {\n                width: 20%;\n                margin: 0 auto;\n                text-align: center;\n            }\n        }\n    }\n}\n\n//MODAL STYLING\n\n@mixin modal($h: auto, $w: auto) {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: $w;\n    height: $h;\n    max-height: 50vh;\n    background-color: #fff;\n    border: 2px solid #000;\n    box-shadow: 24;\n    padding: 10px;\n    overflow-y: auto;\n    @media (max-width: 600px) {\n        width: 95vw;\n    }\n}\n","@import '../../variables.scss';\n\n@keyframes upDown {\n    0% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-5px);\n    }\n\n    100% {\n        transform: translateY(0)\n    }\n}\n\n.paypoint {\n    display: flex;\n    flex-direction: column;\n    background-color: $background;\n    max-width: 97.9vw;\n    align-content: center;\n    justify-content: flex-start;\n    #context-menu{\n        display: none;\n        color: #fff;\n        background-color: $nitroDark;\n        width: 9vw;\n        ul{\n            list-style-type: none;\n            li{\n                cursor: pointer;\n                &:hover{\n                    transform: scale(1.2);\n                    transition: .5s;\n                }\n            }\n        }\n    }\n    .paypoint__main {\n        display: flex;\n        flex-direction: column;\n        background-color: $background;\n        min-height: 49.5vh;\n        width: 80%;\n        margin: auto;\n        margin-top: 2%;\n        h1 {\n            font-size: 2rem;\n            margin-top: 0;\n        }\n        .select_row {\n            display: flex;\n            justify-content: space-around;\n            align-items: center;\n            width: 60vw;\n            margin: 0 auto;\n            select {\n                width: 25%;\n                padding: 1%;\n                border-radius: 1rem;\n                background-color: #fff;\n                &:focus {\n                    border: 1px solid $nitroLight;\n                }\n            }\n            input[type=date] {\n                border: none;\n                background-color: #fff;\n                border-radius: 1rem;\n                height: 4vh;\n            }\n        }\n        .loader {\n            align-self: center;\n            margin: 2% auto;\n        }\n        .paypoint__info {\n            display: flex;\n            flex-direction: column;\n            align-items: center;\n            justify-content: center;\n            margin-top: 1%;\n            margin-left: 0;\n            .info__card {\n                background-color: #fff;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                width: 50vw;\n                border-radius: 1rem;\n                height: 11vh;\n                display: flex;\n                justify-content: space-evenly;\n                align-items: center;\n                position: relative;\n                .card__till {\n                    display: flex;\n                    flex-direction: column;\n                    align-items: center;\n                    justify-content: center;\n                    h3 {\n                        color: $fontColor;\n                        margin: 0 auto;\n                    }\n                }\n                .info__card__icon {\n                    position: absolute;\n                    right: 2%;\n                    bottom: 1.5%;\n                    animation: upDown 1.5s infinite;\n                    -webkit-animation: upDown 1.5s infinite;\n                }\n            }\n            .info__expand {\n                background-color: #fff;\n                box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;\n                width: 60vw;\n                display: flex;\n                justify-content: space-evenly;\n                align-items: flex-start;\n                margin-top: 2%;\n                table {\n                    border: 1px solid $fontColor;\n                    border-collapse: collapse;\n                    width: 100%;\n                    color: $fontColor;\n                    thead {\n                        th {\n                            background-color: $nitroDark;\n                            color: #fff;\n                        }\n                    }\n                    tbody {\n                        tr {\n                            border: 1px solid $fontColor;\n                            // &:nth-child(even) {\n                            //     background-color: #f2f2f2;\n                            // }\n                            cursor: pointer;\n                        }\n                        .noteAdded {\n                            background-image: linear-gradient(225deg, red, red 10px, transparent 10px, transparent);\n                        }\n                        .matched {\n                            background-color: #22FF69;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.force__match{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    p{\n        margin: 0;\n        color: $fontColor;\n    }\n    select{\n        border: 1px solid $nitroDark;\n        border-radius: .5rem;\n    }\n    .force__buttons{\n        display: flex;\n        justify-content: space-evenly;\n        align-items: center;\n        width: 80%;\n        margin: auto;\n        margin-top: 1%;\n        table{\n            color: $fontColor;\n        }\n    }\n    table{\n        width: 100%;\n        margin: auto;\n        border: 1px solid $fontColor;\n        border-collapse: collapse;\n        thead{\n            background-color: $nitroDark;\n            color: #fff;\n        }\n        tbody{\n            tr, th{\n                border: 1px solid $fontColor;\n                cursor: pointer;\n            }\n        }\n    }\n}\n\n\n@media(max-width: $mobile) {\n    main {\n        h1 {\n            font-size: 1.2rem;\n        }\n        .select_row {\n            select {\n                width: 60%;\n                height: 2rem;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
